import React, { useState } from 'react';
import { validate } from '../../../validate';
import { api, getTenant, getUserName } from '../../../../../hooks';
import { IBLSpinLoader } from '../../../../IBLSpinLoader';


const InstitutionMenu = ({ hideInstitutionMenu, setInstitutions, setEducationData }) => {
  const [institutionData, setInstitutionData] = useState({
    name: '',
    institution_type: 'university',
    accreditation: '',
    year_of_establishment: '1990',
    location: '',
    website: '',
    is_current: true,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInstitutionData({ ...institutionData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const requiredFields = ['name', 'institution_type', 'location', 'website'];

  const handleSave = () => {
    const newErrors = validate(institutionData, requiredFields);
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      console.log(newErrors, 'newErrors here');
      return;
    }

    try {
      new URL(institutionData.website); // Validate URL
    } catch (e) {
      setErrors({ ...errors, website: 'Invalid URL format' });
      return;
    }

    setIsLoading(true);

    api.ibldmcareer.postInstitution(
      { org: getTenant(), username: getUserName() },
      JSON.stringify(institutionData),
      (data) => {
        setInstitutions(prevInstitutions => [...prevInstitutions, data]);
        setEducationData(prevEducationData => ({...prevEducationData, institution_id: data.id}));
        setIsLoading(false);
        window.alert('Institution added successfully');
        hideInstitutionMenu();
      },
      (error) => {
        setIsLoading(false);
        window.alert('Something went wrong, Please try again later');
        hideInstitutionMenu();
      }
    );
  };

  return (
    <div
      data-name="followers"
      className="edit_profile_pop add-institution-pop hidden active"
      style={{ display: 'block' }}
    >
      <div className="div-block-520">
        <div className="text-block-386">Add Institution</div>
        <div
          className="cancel_edit_profile w-embed"
          onClick={hideInstitutionMenu}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="var(--accent)"
            height="16px"
            width="16px"
            version="1.1"
            id="Capa_1"
            viewBox="0 0 460.775 460.775"
            xmlSpace="preserve"
          >
            <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55  c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55  c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505  c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55  l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719  c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z" />
          </svg>
        </div>
      </div>
      {isLoading ? (
        <IBLSpinLoader size={40} containerHeight={'200px'} />
      ) : (
        <>
          <div className="div-block-525">
            <div className="div-block-469 sk_s form_div">
              <div className="form_row">
                <div className="text-block-297">Name</div>
                <div className="form-block-15 s_skill w-form">
                  <input
                    className="text-field-14 form_text w-input"
                    maxLength={256}
                    name="name"
                    data-name="Name"
                    placeholder="E.g Harvard"
                    type="text"
                    value={institutionData.name}
                    onChange={handleInputChange}
                  />
                </div>
                { "name" in errors && (
                  <div className="error-message" style={{ color: '#CB112D' }}>
                    {errors.name as string}
                  </div>
                )}
              </div>
              <div className="form_row">
                <div className="text-block-297">Institution type</div>
                <div className="form-block-15 s_skill w-form">
                  <select
                    id="institution_type"
                    name="institution_type"
                    data-name="Institution Type"
                    className="select-field-3 w-select"
                    value={institutionData.institution_type}
                    onChange={handleInputChange}
                  >
                    <option value="university">University</option>
                    <option value="college">College</option>
                    <option value="institute">Institute</option>
                    <option value="institute">Institute</option>
                    <option value="academy">Academy</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                  { "institution_type" in errors && (
                  <div className="error-message" style={{ color: '#CB112D' }}>
                        {errors.institution_type as string}
                  </div>
                )}
              </div>
              <div className="form_row">
                <div className="text-block-297">Accreditation</div>
                <div className="form-block-15 s_skill w-form">
                  <input
                    className="text-field-14 form_text w-input"
                    maxLength={256}
                    name="accreditation"
                    data-name="Accreditation"
                    placeholder="E.g WASC"
                    type="text"
                    value={institutionData.accreditation}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="form_row">
                <div className="text-block-297">Year of establishment</div>
                <div className="form-block-15 s_skill w-form">
                  <select
                    id="year_of_establishment"
                    name="year_of_establishment"
                    data-name="Year of Establishment"
                    className="select-field-3 w-select"
                    value={institutionData.year_of_establishment}
                    onChange={handleInputChange}
                  >
                    {Array.from(
                      { length: 2024 - 1800 + 1 },
                      (_, i) => 2024 - i
                    ).map((year) => (
                      <option key={year} value={year.toString()}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form_row">
                <div className="text-block-297">Location</div>
                <div className="form-block-15 s_skill w-form">
                  <input
                    className="text-field-14 form_text w-input"
                    maxLength={256}
                    name="location"
                    data-name="Location"
                    placeholder="E.g Silicon Valley, CA"
                    type="text"
                    value={institutionData.location}
                    onChange={handleInputChange}
                  />
                </div>
                {  "location" in errors && (
                  <div className="error-message" style={{ color: '#CB112D' }}>
                    {errors.location as string}
                  </div>
                )}
              </div>
              <div className="form_row">
                <div className="text-block-297">Website URL</div>
                <div className="form-block-15 s_skill w-form">
                  <input
                    className="text-field-14 form_text w-input"
                    maxLength={256}
                    name="website"
                    data-name="Website URL"
                    placeholder="https://www.bl.ai"
                    type="url"
                    value={institutionData.website}
                    onChange={handleInputChange}
                  />
                </div>
                { "website" in errors && (
                  <div className="error-message" style={{ color: '#CB112D' }}>
                    {errors.website as string }
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="popup-f add_content">
            <div
              className="div-block-475 cancel_edit_prof"
              onClick={hideInstitutionMenu}
            >
              <div className="text-block-284 cancel_dc">Cancel</div>
            </div>
            <div
              className="div-block-475 save_profile_info"
              onClick={handleSave}
            >
              <div className="text-block-284 add_skill_text">Save</div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default InstitutionMenu;
